import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

export function Table(tableProps: ComponentProps<'table'>) {
  const { className, ...props } = tableProps;
  return <table data-slot="table" className={cn('w-full caption-bottom text-sm', className)} {...props} />;
}

export function TableHeader(tableHeaderProps: ComponentProps<'thead'>) {
  const { className, ...props } = tableHeaderProps;
  return <thead data-slot="table-header" className={cn('box-content h-11 [&_tr]:border-b', className)} {...props} />;
}

export function TableBody(tableBodyProps: ComponentProps<'tbody'>) {
  const { className, ...props } = tableBodyProps;
  return <tbody data-slot="table-body" className={cn('[&_tr:last-child]:border-0', className)} {...props} />;
}

export function TableFooter(tableFooterProps: ComponentProps<'tfoot'>) {
  const { className, ...props } = tableFooterProps;
  return <tfoot data-slot="table-footer" className={cn('bg-background border-t font-medium [&>tr]:last:border-b-0', className)} {...props} />;
}

export function TableRow(tableRowProps: ComponentProps<'tr'>) {
  const { className, ...props } = tableRowProps;
  return <tr data-slot="table-row" className={cn('hover:bg-muted/20 data-[state=selected]:bg-muted/40 dark:data-[state=selected]:bg-muted/50 border-b transition-colors', className)} {...props} />;
}

export function TableHead(tableHeadProps: ComponentProps<'th'>) {
  const { className, ...props } = tableHeadProps;
  return (
    <th
      data-slot="table-head"
      className={cn('text-accent-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 *:[[role=checkbox]]:translate-y-[2px]', className)}
      {...props}
    />
  );
}

export function TableCell(tableCellProps: ComponentProps<'td'>) {
  const { className, ...props } = tableCellProps;
  return <td data-slot="table-cell" className={cn('p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 *:[[role=checkbox]]:translate-y-[2px]', className)} {...props} />;
}

export function TableCaption(tableCaptionProps: ComponentProps<'caption'>) {
  const { className, ...props } = tableCaptionProps;

  return <caption data-slot="table-caption" className={cn('text-muted-foreground mt-4 text-sm', className)} {...props} />;
}
